import { useSelector } from 'react-redux';
import * as selectors from '../selectors';
export default function useFeatures() {
    return useSelector(selectors.features);
}
